import {EventEmitter} from 'eventemitter3'
import {genericLogQueryType} from '../../styled-component/generic-log/GenericLogConstansts'

export const genericLogEvent = new EventEmitter()

export const genericLogEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
}

export function getGenericLogEventKey(
    eventType,
    logType = genericLogQueryType.none,
) {
    if (!eventType || !logType || logType === genericLogQueryType.none) {
        return ''
    }

    switch (eventType) {
        case genericLogEventTypes.TABLE_CHANGE:
            return `GENERIC_LOG_TABLE_CHANGE-` + logType

        default:
            return ''
    }
}

export function onGenericLogTableChangeListener(
    eventType = genericLogEventTypes.TABLE_CHANGE,
    data,
) {
    genericLogEvent.emit(getGenericLogEventKey(eventType, data?.type), data)
}

export function onGenericLogTableChangeRemoveListener(
    eventType = genericLogEventTypes.TABLE_CHANGE,
) {
    genericLogEvent.removeListener(getGenericLogEventKey(eventType))
}
